// This is just an example,
// so you can safely delete all default props below

import type { MessageContext } from 'vue-i18n'

export default {
  system_error: 'Извините, произошла системная ошибка',
  service_not_available: 'Сервис временно недоступен',
  success_perform_msg: 'Операция успешно отработана',

  errorStatus: {
    401: 'Вы не авторизованы',
    408: 'Время ожидания запроса истекло. Попробуйте снова',
    409: 'Данные были изменены другим пользователем. Попробуйте ещё раз.',
    422: 'Ошибка 422: некорректные данные',
    429: 'Превышен лимит запросов. Повторите попытку позднее',
    500: 'Ошибка сервера',
    504: 'Время ожидания ответа от сервера истекло. Попробуйте позже',
  },
  error: {
    unknown: 'Что-то пошло не так',
    timeout: 'Время ожидания запроса истекло. Попробуйте снова',
    network: 'Ошибка сети. Проверьте подключение к интернету',
    forbidden: 'Нет доступа',
    employeeRequired: 'Действие доступно только сотрудникам',
    subdivisionRequired: 'Выберите подразделение в профиле',
  },

  productQuantity: '{n} товаров | {n} товар | {n} товара | {n} товаров',
  bonus: 'бонусов | бонус | бонуса | бонусов',
  to_bonus: 'бонусов | бонуса | бонусов | бонусов',
  chips: '{n} фишек | {n} фишка | {n} фишки | {n} фишек',
  payment: {
    creditBroker: 'Рассрочка/Кредит Онлайн',
    mobile: 'Kaspi QR',
    halykQR: 'Halyk QR',
  },
  attempts: '{n} попыток | {n} попытка | {n} попытки | {n} попыток',
  shipment: {
    pickup: 'Самовывоз',
    delivery: 'Доставка',
  },
  gifts: '{n} подарков | {n} подарок | {n} подарка | {n} подарков',
  availableAmountGifts:
    'Доступно {n} подарков | Доступен {n} подарок | Доступно {n} подарка | Доступно {n} подарков',
  amountGiftPromoTitle:
    'Доступно {n} подарков к заказу | Доступен подарок к заказу | Доступны {n} подарка к заказу | Доступно {n} подарков к заказу',
  amountGiftPromoText: ({ values: { n } }: MessageContext) => {
    return n === 1
      ? 'Покупателю доступен подарок — выберите его прямо сейчас'
      : 'Покупателю доступны подарки — выберите их прямо сейчас'
  },
  amountGiftRemainingTitle: 'Вы выбрали не все подарки',
  amountGiftRemainingText: 'Покупателю доступен ещё @:{\'gifts\'}',
  selectGifts:
    'Выберите подарок | Выберите подарок | Выберите подарки | Выберите подарки',
  hours: '{n} часов | {n} час | {n} часа | {n} часов',
  minutes: '{n} минут | {n} минута | {n} минуты | {n} минут',
  seconds: '{n} секунд | {n} секунда | {n} секунды | {n} секунд',
  paymentTypes: {
    cashAtShop: 'Оплата наличными (в магазине)',
    cashToCourier: 'Оплата наличными (курьеру)',
    cardToCourier: 'Оплата картой (при получении)',
    cardOnline: 'Оплата картой (на сайте)',
    cardAtShop: 'Оплата картой (в магазине)',
    kaspi: 'Оплата через Kaspi',
    bonuses: 'Оплата бонусами',
    credit: 'Покупка в кредит',
    cashless: 'Безналичная оплата',
  },
  validation: {
    mixed: {
      required: 'Обязательное поле',
    },
    string: {
      length: 'Поле должно состоять из {n} символов',
    },
  },
  sort: {
    label: 'Сортировка',
    desc: 'Сначала новые',
    asc: 'Сначала старые',
  },
  all: 'Все',
  onlyMine: 'Только мои',
  noData: 'Нет данных',
  appInteractionUnavailable: 'Взаимодействие через приложение недоступно',
  noCustomerDataInOrder: 'В чек-заявке нет данных покупателя',
  day: '{n} дней | {n} день | {n} дня | {n} дней',
  productAdded:
    'Добавлены товары | Добавлен товар | Добавлены товары | Добавлены товары',
  bagAdded:
    'Добавлены пакеты | Добавлен пакет | Добавлены пакеты | Добавлены пакеты',
  orderStatus: {
    DRAFT: 'В процессе',
    PENDING_PAYMENT: 'Ожидает оплаты',
    PAID: 'Оплачена',
    CANCELLED: 'Отменена',
    COMPLETED: 'Завершена',
    REFUNDED: 'Возврат',
    READY_FOR_ISSUE: 'Готов к выдаче',
  },
  reasonType: {
    shopFault: 'По вине магазина/продавца',
    clientRequest: 'По желанию клиента',
    factoryDefect: 'Заводской брак или недокомплект',
  },
}
